import { Controller } from "@hotwired/stimulus"
import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper"

const LFHQ_LABELS = `
  ^XA
  ^FX Top section with logo, name and address.
  ^CF0,35
  ^FO30,30^FD19 of 20 cs^FS
  ^CF0,20
  ^FO800,30,1^FB800,2,0,C^FDMarty's Local\\&^FS
  ^FO780,30,1^FB300,2,0,R^FDSO #####^FS

  ^CF0,30
  ^FO800,90,1^FB800,4,0,C^FDMILLSTONE FARM MARKET\\&^FS

  ^CF0,45
  ^FO800,150,1^FB780,2,0,C^FDTonic, Original "Wildflower Honey" Fire Cider - Organic\\&^FS
  ^CF0,35
  ^FO800,245,1^FB800,2,0,C^FDCASE: 6 x 8 oz.\\&^FS
  ^CF0,35
  ^FO800,295,1^FB800,2,0,C^FDShire City Herbals\\&^FS

  ^CF0,20
  ^FO30,370^FDRoute Name^FS
  ^CF0,40
  ^FO780,350,1^FB300,2,0,R^FDBIN#^FS
  ^XZ

  ^XA
  ^FX Top section with logo, name and address.
  ^CF0,35
  ^FO30,30^FD29 of 20 cs^FS
  ^CF0,20
  ^FO800,30,1^FB800,2,0,C^FDMarty's Local\\&^FS
  ^FO780,30,1^FB300,2,0,R^FDSO #####^FS

  ^CF0,30
  ^FO800,90,1^FB800,4,0,C^FDMILLSTONE FARM MARKET\\&^FS

  ^CF0,45
  ^FO800,150,1^FB780,2,0,C^FDTonic, Original "Wildflower Honey" Fire Cider - Organic\\&^FS
  ^CF0,35
  ^FO800,245,1^FB800,2,0,C^FDCASE: 6 x 8 oz.\\&^FS
  ^CF0,35
  ^FO800,295,1^FB800,2,0,C^FDShire City Herbals\\&^FS

  ^CF0,20
  ^FO30,370^FDRoute Name^FS
  ^CF0,40
  ^FO780,350,1^FB300,2,0,R^FDBIN#^FS
  ^XZ
`

// Connects to data-controller="zebra-print-test"
export default class extends Controller {
  static targets = ["deviceSelect", "writeText"]

  connect() {
    this.browserPrint = new ZebraBrowserPrintWrapper()
    this.devices = []
    this.setup()
  }

  async setup() {
    try {
      const defaultPrinter = await this.browserPrint.getDefaultPrinter()
      this.browserPrint.setPrinter(defaultPrinter)
      this.addDeviceOption(defaultPrinter)

      const available = await this.browserPrint.getAvailablePrinters()
      available.forEach((device) => {
        if (device.uid && device.uid === defaultPrinter.uid) return
        this.addDeviceOption(device)
      })
    } catch (error) {
      alert(error)
    }
  }

  addDeviceOption(device) {
    const option = document.createElement("option")
    option.text = device.name || device.uid || JSON.stringify(device)
    option.value = this.devices.length
    this.devices.push(device)
    this.deviceSelectTarget.add(option)
  }

  selectDevice() {
    const device = this.devices[this.deviceSelectTarget.value]
    if (device) this.browserPrint.setPrinter(device)
  }

  printLfhqLabels() {
    this.write(LFHQ_LABELS)
  }

  sendConfigLabel() {
    this.write("~wc")
  }

  sendZplLabel() {
    this.write("^XA^FO200,200^A0N36,36^FDTest Label^FS^XZ")
  }

  async getStatus() {
    await this.write("~hs")
    await this.read()
  }

  async getLocalDevices() {
    try {
      const devices = await this.browserPrint.getAvailablePrinters()
      alert("Devices: \n" + JSON.stringify(devices, null, 4))
    } catch (error) {
      alert(error)
    }
  }

  writeInput() {
    this.write(this.writeTextTarget.value)
  }

  async read() {
    try {
      const data = await this.browserPrint.read()
      alert(data || "No Response from Device")
    } catch (error) {
      alert("Error: " + error)
    }
  }

  async write(data) {
    try {
      await this.browserPrint.write(data)
    } catch (error) {
      alert("Error: " + error)
    }
  }
}
